<template>
  <v-container style="height: 100%">
    <!--<v-layout row justify-center>-->
    <!--<v-flex md10>-->
    <v-card flat>
      <v-card-title class="title subprimary">
        <span>Персоны:</span>
        <v-spacer></v-spacer>
        <v-btn @click="opened_form = true" color="secondary" flat>
          <v-icon>add</v-icon>
          Добавить
        </v-btn>
        <v-btn @click="getItems()" color="primary" icon flat><v-icon>update</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pb-3 pt-1">
        <v-layout justify-center>
          <v-flex>
            <v-data-table
              :headers="headers"
              :items="items"
              :pagination.sync="pagination"
              :total-items="total"
              :loading="loading"
              class="elevation-1"
              :rows-per-page-items="[10,15,100]"
              no-data-text="Нет данных"
              rows-per-page-text="Число элементов"
            >
              <template slot="items" slot-scope="props" class="text-xl-left">

                <td class="text-xl-left">
                  <div  v-for="item, i in props.item.lastName">
                    {{item.text}}
                  </div>
                </td>
                <td class="text-xl-left">
                  <div  v-for="item, i in props.item.firstName">
                    {{item.text}}
                  </div>
              </td>
                <td class="text-xl-left">
                  <div  v-for="item, i in props.item.patronymic">
                    {{item.text}}
                  </div>
                </td>
                <td class="text-xl-left">  {{props.item.birthday}}</td>
                <td class="text-xl-left">
                  <div  v-for="item, i in props.item.post">
                    {{item.text}}
                  </div>
                </td>
                <td class="text-xl-left"  v-bind="selected">
<!--                  <a :href="makeTokenUrl(props.item.token)" >Доступ по ссылке</a>-->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="contentCopy(props.item)"
                        medium
                      >
                        content_copy
                      </v-icon>
                    </template>
                    <span>Скопировать ссылку</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="updateToken(props.item)"
                        medium
                      >
                        update
                      </v-icon>
                    </template>
                    <span>Сменить token</span>
                  </v-tooltip>
                </td>
                <td class="text-xl-left " v-bind="selected">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="updateItem(props.item)"
                        class="mr-2"
                        medium
                      >
                        edit
                      </v-icon>
                    </template>
                    <span>Редактировать</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="openConfirmDelete(props.item)"
                        medium
                      >
                        delete
                      </v-icon>
                    </template>
                    <span>Удалить</span>
                  </v-tooltip>
                </td>
              </template>
              <template slot="no-data">
                <v-btn @click="getItems()" color="primary">Обновить</v-btn>
              </template>
            </v-data-table>

          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog @input="closedForm" v-model="opened_form" width="500" persistent>
      <Person @addItem="addItem"
                    @ended="closedForm"
                    @refreshItem="refreshItem"
                    v-bind="selected"
                    v-if="opened_form"
      >
      </Person>
    </v-dialog>

    <v-dialog persistent v-model="opened_confirm" width="500">
      <v-card v-if="deletable">
        <v-card-title>Подтвердите удаление</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Вы уверены что хотите удалить персону?<br>
        </v-card-text>
        <v-card-actions>
          <v-flex>
            <v-btn
              @click="deleteItem(deletable.id)"
              color="warning"
              flat
            >
              Удалить
            </v-btn>
            <v-btn
              @click="closeConfirmDelete"
              flat
            >Отмена
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--</v-flex>-->
    <!--</v-layout>-->
  </v-container>
</template>


<script>
    import Person  from "../forms/Person"
    import urls from "../../../../../modules/petition/urls"
    import UserDataMixin from '../../../../../mixins/UserDataMixin'
    import {makeGetRequest,makeParticalUpdateRequest} from "../../../../../helper";

    export default {
        name: "ListPerson",
        components: {Person},
        mixins: [UserDataMixin],

        data () {
            return {
                URL_LIST: urls.getUrl('admin|core|models|person-list', 'list'),
                URL_DELETE: urls.getUrl('admin|core|models|person-detail', 'destroy'),

                total: 0,
                items: [],
                loading: true,
                pagination: {},
                headers: [
                    { text: 'Фамилия', sortable: false, align: 'justify-center', },
                    { text: 'Имя', sortable: false, align: 'justify-center', },
                    { text: 'Отчество', sortable: false, align: 'justify-center', },
                    { text: 'Дата рождения', sortable: false, align: 'justify-center', },
                    { text: 'Место работы', sortable: false, align: 'justify-center', },
                  { text: 'token доступа', sortable: false, align: 'justify-center', },
                    {
                        text: 'Действия', sortable: false, align: 'justify-center',
                        // class: 'headline'
                    }
                ]
            }
        },
        watch: {
            pagination: {
                handler () {
                    this.getItems()
                },
                deep: true
            }
        },
        mounted () {
            this.getItems()
        },
        methods: {
            contentCopy(item){
              var textArea = document.createElement("textarea");
              textArea.value = this.makeTokenUrl(item.token);
              document.body.appendChild(textArea);
              textArea.select();
              try {
                var successful = document.execCommand('copy');
                alert('Скопировано в буфер')
              }
              catch (err)
              {
                console.log('Oops, unable to copy');
              }
              textArea.parentNode.removeChild(textArea);
            },

            updateToken(item){
              let data = {
                token:this.uuidv4()
              }
              makeParticalUpdateRequest(this.URL_DELETE.replace('<id>',item.id),data).then(resp => {
                if (!resp.ok) {
                   alert('Не удалось сменить')
                }else {
                  alert('Успешно')
                  this.getItems()
                }
              })

            },

            makeTokenUrl(token){
              let str = String(window.location).replace('dissertation/diss','dissertation/'+token+'/diss')
              return  str.substr(0, str.indexOf('/admin'))
            },
            uuidv4() {
              return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
              (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
              );
            },
            addItem(){
                this.closedForm()
                this.getItems();
            },
            getItems () {
                this.loading = true
                let url =  process.env.VUE_APP_API_HOST +"council/admin/core/models/person/"+"?page="+this.pagination.page +"&page_size="+ this.pagination.rowsPerPage
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }) .then(json => {
                    this.items = json.results
                    this.total = json.count
                    this.loading = false
                })
            },
        }
    }


</script>
<style scoped>

</style>
